import { render, staticRenderFns } from "./my_demand_manage.vue?vue&type=template&id=15f4b538&scoped=true"
import script from "./my_demand_manage.vue?vue&type=script&lang=js"
export * from "./my_demand_manage.vue?vue&type=script&lang=js"
import style0 from "./my_demand_manage.vue?vue&type=style&index=0&id=15f4b538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f4b538",
  null
  
)

export default component.exports